/**
 * Reordena produtos da coleção para garantir que produtos esgotados
 * sempre apareçam ao final, independente da paginação
 */
(function() {
  'use strict';

  function sortProductsByAvailability() {
    const productGrid = document.querySelector('.collection__products');
    if (!productGrid) return;

    // Verifica se já foi ordenado para evitar reordenações desnecessárias
    const alreadySorted = productGrid.getAttribute('data-products-sorted') === 'true';

    // Seleciona todos os cards de produtos
    const productCards = Array.from(productGrid.querySelectorAll('.product-item'));
    if (productCards.length === 0) return;

    // Separa produtos disponíveis e esgotados
    const availableProducts = [];
    const unavailableProducts = [];

    productCards.forEach(card => {
      // Verifica se o produto está esgotado através do badge específico do tema
      const soldOutBadge = card.querySelector('.product-badge--sold-out');
      const isUnavailable = soldOutBadge !== null;

      if (isUnavailable) {
        unavailableProducts.push(card);
      } else {
        availableProducts.push(card);
      }
    });

    // Verifica se a reordenação é necessária
    const needsReordering = !alreadySorted &&
                           unavailableProducts.length > 0 && 
                           availableProducts.length > 0 &&
                           isOutOfOrder(productCards, availableProducts, unavailableProducts);

    if (!needsReordering) {
      // Garante que o grid está visível mesmo se não precisar reordenar
      if (productGrid.style.opacity !== '1') {
        productGrid.style.opacity = '1';
      }
      productGrid.setAttribute('data-products-sorted', 'true');
      return;
    }

    // Oculta temporariamente o grid para evitar quebra visual
    productGrid.style.opacity = '0';
    productGrid.style.transition = 'none';

    // Pequeno delay para garantir que a opacidade foi aplicada
    requestAnimationFrame(() => {
      // Remove todos os produtos do grid
      productCards.forEach(card => card.remove());

      // Reinsere na ordem correta: disponíveis primeiro, esgotados depois
      availableProducts.forEach(card => productGrid.appendChild(card));
      unavailableProducts.forEach(card => productGrid.appendChild(card));

      // Marca como ordenado
      productGrid.setAttribute('data-products-sorted', 'true');

      // Força reflow antes de mostrar novamente
      productGrid.offsetHeight;

      // Mostra o grid novamente com transição suave
      requestAnimationFrame(() => {
        productGrid.style.transition = 'opacity 0.3s ease';
        productGrid.style.opacity = '1';
      });
    });
  }

  // Verifica se os produtos estão fora de ordem
  function isOutOfOrder(allCards, availableCards, unavailableCards) {
    if (unavailableCards.length === 0) return false;
    
    const firstUnavailableIndex = allCards.indexOf(unavailableCards[0]);
    const lastAvailableIndex = availableCards.length > 0 ? 
                                allCards.indexOf(availableCards[availableCards.length - 1]) : -1;
    
    return firstUnavailableIndex < lastAvailableIndex;
  }

  // Executa ao carregar a página
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sortProductsByAvailability);
  } else {
    sortProductsByAvailability();
  }

  // Executa após atualizações de filtros/paginação
  document.addEventListener('collection:updated', sortProductsByAvailability);

  // Observer para detectar mudanças no DOM (infinite scroll, filtros AJAX)
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.addedNodes.length > 0) {
        // Verifica se novos produtos foram adicionados
        const hasNewProducts = Array.from(mutation.addedNodes).some(node => 
          node.nodeType === 1 && (
            node.classList && node.classList.contains('product-item') ||
            node.querySelector && node.querySelector('.product-item')
          )
        );
        
        if (hasNewProducts) {
          // Pequeno delay para garantir que o DOM está completo
          setTimeout(sortProductsByAvailability, 100);
        }
      }
    });
  });

  // Observa mudanças no container de produtos
  const productContainer = document.querySelector('.collection__products');
  if (productContainer) {
    observer.observe(productContainer, {
      childList: true,
      subtree: true
    });
  }
})();
